<!-- TODO: Delete file if not needed -->
<script setup>
const emit = defineEmits(['hide'])
const { currentProviderLogoUrl, currentProviderName } = useSessionData()
const { t } = useI18n()
const { r } = useRoutes()

const modal = ref(undefined)
const schema = computed(() => [
  {
    $formkit: 'text',
    name: 'email',
    label: t('Email'),
    validation: 'required|email',
  },
])

async function redirectToLoginPage(value) {
  window.location.href = r({
    path: `/login/?email=${encodeURIComponent(value.email)}`,
    isV2Path: false,
  })
}

function show() {
  modal.value.show()
}
function hide() {
  modal.value.hide()
}

function onHide() {
  emit('hide')
}

defineExpose({
  show,
  hide,
})
</script>

<template>
  <DSModal
    ref="modal"
    modal-class="w-414px !rounded-8px"
    @hide="onHide"
  >
    <div class="modal__container flex flex-col flex-gap-6 p-8">
      <div class="flex flex-col items-center flex-gap-4">
        <BaseImage
          v-if="currentProviderLogoUrl"
          :src="currentProviderLogoUrl"
          class="h-60px w-auto"
        />
        <p class="text-2xl color-secondary-400 fw-700">
          {{ t('Welcome to {provider}', { provider: currentProviderName }) }}
        </p>
        <p class="text-sm text-text-400">
          {{ t('Enter your email to get started') }}
        </p>
      </div>
      <div>
        <FormKit
          type="form"
          :submit-label="t('Next')"
          @submit="redirectToLoginPage"
        >
          <FormKitSchema :schema="schema" />
        </FormKit>
      </div>
    </div>
  </DSModal>
</template>

<i18n>
{
  "en-us": {
    "Welcome to {provider}": "Welcome to {provider}",
    "Enter your email to get started": "Enter your email to get started",
    "Email": "Email",
    "Next": "Next"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Welcome to {provider}": "Willkommen bei {provider}",
  "Enter your email to get started": "Geben Sie Ihre E-Mail-Adresse ein, um loszulegen",
  "Email": "E-Mail",
  "Next": "Weiter"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Welcome to {provider}": "Bienvenue chez {provider}",
  "Enter your email to get started": "Saisissez votre e-mail pour commencer",
  "Email": "E-mail",
  "Next": "Suivant"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Welcome to {provider}": "Le damos la bienvenida a {provider}",
  "Enter your email to get started": "Introduzca su correo electrónico para comenzar",
  "Email": "Correo electrónico",
  "Next": "Siguiente"
}
</i18n>
